import React from "react";
import PropTypes from "prop-types";
import VertBarChart from "../VertBarChart";
import SimpleLegend from "../SimpleLegend";
import { BlurbPto, BlurbExtraWork } from "../Text";
import { COLORS } from "../../utils/constants";

const JudgeDay = ({ selectedJudgeData, year }) => {
  const {
    totalDaysWithEvents,
    totalDaysWithNoEvents,
    ndwDays,
    lastName,
  } = selectedJudgeData;
  const chartData = [{ year, totalDaysWithEvents, totalDaysWithNoEvents }];
  const stackCategories = [
    {
      accessor: "totalDaysWithEvents",
      label: "Days with case events",
      fill: COLORS.chartPrimary,
    },
    {
      accessor: "totalDaysWithNoEvents",
      label: "Days with no case events",
      fill: COLORS.chartNoData,
    },
  ];
  let paidTimeOff = null;
  let annotationLabel = null;
  let annotationDefaultPos = null;
  let tooltipComponent;
  let refCandyStripe;
  if (ndwDays > 0) {
    annotationLabel = [
      "Equivalent of",
      <tspan>
        <tspan className="panel__judge-text-emphasis">{ndwDays}</tspan> days without case events
      </tspan>,
    ];
    paidTimeOff = [243 - ndwDays, 243];
    annotationDefaultPos = "right";
    tooltipComponent = (
      <BlurbPto lastName={lastName} paidTimeOff={ndwDays} year={year} />
    );
    refCandyStripe = COLORS.chartRefArea2;
  } else {
    const extraWorkDays = ndwDays * -1;
    annotationLabel = [
      <tspan>
        Held case events
      </tspan>,
      <tspan>
        {"on "}
        {extraWorkDays}
        {" extra "}
        {extraWorkDays === 1 ? "day" : "days"}
      </tspan>
    ];
    paidTimeOff = [243, totalDaysWithEvents];
    annotationDefaultPos = "left";
    tooltipComponent = (
      <BlurbExtraWork
        lastName={lastName}
        extraWorkDays={extraWorkDays}
        year={year}
      />
    );
    refCandyStripe = COLORS.chartRefArea1;
  }
  return (
    <div className="panel__judge-day-container">
      <SimpleLegend legendItems={stackCategories} data={chartData[0]} />

      <div className="panel__judge-day-chart-container">
        <VertBarChart
          data={chartData}
          dataKey="year"
          dataYear={year}
          stackCategories={stackCategories}
          annotationLabel={annotationLabel}
          refAreaValue={ndwDays}
          refAreaRange={paidTimeOff}
          refAreaFill={refCandyStripe}
          refAreaLineColor={COLORS.chartRefLines}
          annotationDefaultPos={annotationDefaultPos}
          tooltipPayload={tooltipComponent}
          hideRefLines
        />
      </div>
    </div>
  );
};

JudgeDay.propTypes = {
  selectedJudgeData: PropTypes.objectOf(PropTypes.any).isRequired,
  year: PropTypes.number.isRequired,
};

export default JudgeDay;
